import { authorizedFetch, ErrorResponse } from './api-client';
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export interface WizardAvailableDay {
  slot_date: string;
  free_slots: number;
  weekday: string;
}

export interface WizardAvailableSlot {
  slot_id: string;
  slot_id_b?: string | null;   // presente apenas em double_slot
  slot_time: string;
  dentist_name: string;
  double_slot: boolean;
}

export interface WizardConfirmRequest {
  patient_id: string;
  slot_id: string;
  slot_id_b?: string | null;   // obrigatório quando double_slot=true
  double_slot?: boolean;
  original_appointment_id?: string;
  dental_insurance_id?: string;
  card_number?: string;
}

/**
 * Busca dias disponíveis com contagem de vagas
 */
export async function fetchWizardAvailableDays(
  clinicId: string,
  specialtyId: string,
  month: string,           // Formato YYYY-MM
  doubleSlot = false
): Promise<WizardAvailableDay[]> {
  const params = new URLSearchParams({
    clinic_id: clinicId,
    specialty_id: specialtyId,
    month,
    double_slot: doubleSlot.toString(),
  });

  const response = await authorizedFetch(
    `${API_BASE_URL}/api/v1/appointment-wizard/available-days?${params.toString()}`
  );

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao buscar dias disponíveis');
  }

  return response.json();
}

/**
 * Busca horários/slots específicos de um dia
 */
export async function fetchWizardAvailableSlots(
  clinicId: string,
  specialtyId: string,
  slotDate: string,        // Formato YYYY-MM-DD
  doubleSlot = false
): Promise<WizardAvailableSlot[]> {
  const params = new URLSearchParams({
    clinic_id: clinicId,
    specialty_id: specialtyId,
    slot_date: slotDate,
    double_slot: doubleSlot.toString(),
  });

  const response = await authorizedFetch(
    `${API_BASE_URL}/api/v1/appointment-wizard/available-slots?${params.toString()}`
  );

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao buscar horários');
  }

  return response.json();
}

/**
 * Retorna os IDs dos dentistas que têm slots na data informada
 */
export async function fetchDentistIdsOnDate(
  clinicId: string,
  slotDate: string   // Formato YYYY-MM-DD
): Promise<string[]> {
  const params = new URLSearchParams({ clinic_id: clinicId, slot_date: slotDate });
  const response = await authorizedFetch(
    `${API_BASE_URL}/api/v1/appointment-wizard/dentists-on-date?${params.toString()}`
  );
  if (!response.ok) throw new Error('Erro ao buscar dentistas do dia');
  return response.json();
}

/**
 * Finaliza o agendamento (Novo ou Remarcação, simples ou duplo)
 */
export async function confirmWizardBooking(
  data: WizardConfirmRequest
): Promise<{ id: string }> {
  const response = await authorizedFetch(
    `${API_BASE_URL}/api/v1/appointment-wizard/confirm`,
    {
      method: 'POST',
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao confirmar agendamento');
  }

  return response.json();
}